
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ThankYouMessage from "@/components/ui-custom/ThankYouMessage";
import { getPublicConfig } from "@/api/publicConfig";

const ThankYou: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const service = searchParams.get('service');
  const leadId = searchParams.get('leadId');

  useEffect(() => {
    const trackConversion = async () => {
      try {
        // Get Facebook Pixel ID and Google Analytics ID from site settings
        // This will work with RLS because we have a public policy for these specific fields
        const data = await getPublicConfig();

        if (!data.fb_pixel_id && !data.ga_id) {
          return;
        }
        
        // Track conversion with Facebook Pixel if it's available
        if (window.fbq && data.fb_pixel_id) {
          // Standard Lead event
          window.fbq('track', 'Lead');
          
          // Custom conversion for specific service if provided
          if (service) {
            window.fbq('trackCustom', `Lead_${service}`, {
              service: service,
              lead_id: leadId || 'unknown'
            });
          }
          
          console.log('Facebook Pixel: Conversion tracked successfully');
        }
        
        // Track with Google Analytics if available
        if (window.gtag && data.ga_id) {
          window.gtag('event', 'conversion', {
            'send_to': data.ga_id,
            'event_category': 'lead',
            'event_label': service || 'lead_form',
            'value': 1
          });
          
          console.log('Google Analytics: Conversion tracked successfully');
        }
      } catch (error) {
        console.error('Error tracking conversion:', error);
      }
    };
    
    trackConversion();
  }, [service, leadId]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 via-white to-slate-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <ThankYouMessage serviceName={service} />
      </div>
    </div>
  );
};

export default ThankYou;
